<div [ngStyle]="{ 'display' : barometricToolController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <form autocomplete="off"  id="ngBarometricToolController" [formGroup]="form" [ngClass]="[this.barometricToolController.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']" name="ngBarometricToolController" #ngBarometricToolController="ngForm" id="barometricToolForm" style="height: 600px">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Input Parameters</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Altitude</label>
            <div class="coordenates">
              <input type="number" formControlName="altitudeFeets" style="width: 35%;" [(ngModel)]="altitudeFeets" (input)="this.updateAltitudeMeters($event.target.value)"/>
                <span>[ft]</span>
              <input type="number" formControlName="altitudeMeters" style="width: 35%;" [(ngModel)]="altitudeMeters" (input)="this.updateAltitudeFeets($event.target.value)"/>
                <span>[m]</span>
                <span class="error" *ngIf="form.get('altitudeFeets').errors">
                  The Altitude value should be greater than -999999999.
                  </span>
            </div>
          </div>
          <div>
            <label for="">Temperature</label>
            <div class="coordenates">
              <input type="number" formControlName="temperatureD" style="width: 35%;" [(ngModel)]="temperatureD" (input)="this.updateTemperatureDegrees($event.target.value)"/>
                <span>[Cº]</span>
              <input type="number" formControlName="temperatureF" style="width: 35%;" [(ngModel)]="temperatureF" (input)="this.updateTemperatureFahrenheit($event.target.value)"/>
                <span>[F]</span>
                <span class="error" *ngIf="form.get('temperatureD').errors">
                  The temperature value should be defined between -80º and 80º.
                  </span>
            </div>
          </div>
          <div>
            <label for="">Pressure</label>
            <div class="coordenates">
              <input type="number" formControlName="pressureHpa" style="width: 35%;" [(ngModel)]="presureHpa" (input)="this.updatePresureHpa($event.target.value);"/>
                <span>[hPa]</span>
              <input type="number" formControlName="pressureInHg" style="width: 35%;" [(ngModel)]="presureinHg" (input)="this.updatePresureHg($event.target.value)"/>
                <span>[inHg]</span>
                <span class="error" *ngIf="form.get('pressureHpa').errors">
                  The Pressure value should be defined between 800 and 1200 hPa.
                  </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Results</h4>
          <span> </span>
        </div>
        <div class="input-fields">
          <div>
            <label for="">Corrected Temperature Altitude</label>
            <div class="coordenates">
              <input type="number" formControlName="correctedTemperatureAltitudeFeets" style="width: 35%;" [(ngModel)]="correctedTemperatureAltitudeFeets"/>
                <span>[ft]</span>
              <input type="number" formControlName="correctedTemperatureAltitudeMeters" style="width: 35%;" [(ngModel)]="correctedTemperatureAltitudeMeters"/>
                <span>[m]</span>
            </div>
          </div>
          <div>
            <label for="">Corrected Pressure Altitude</label>
            <div class="coordenates">
              <input type="number" formControlName="correctedPressureAltitudeFeets" style="width: 35%;" [(ngModel)]="correctedPressureAltitudeFeets"/>
                <span>[ft]</span>
              <input type="number" formControlName="correctedPressureAltitudeMeters" style="width: 35%;" [(ngModel)]="correctedPressureAltitudeMeters"/>
                <span>[m]</span>
            </div>
          </div>
          <div>
            <label for="">Temperature + Pressure Correction</label>
            <div class="coordenates">
              <input type="number" formControlName="temperaturePressureCorrectionFeets" style="width: 35%;" [(ngModel)]="temperaturePressureCorrectionFeets"/>
                <span>[ft]</span>
              <input type="number"  formControlName="temperaturePressureCorrectionMeters" style="width: 35%;" [(ngModel)]="temperaturePressureCorrectionMeters"/>
                <span>[m]</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
